<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title" v-if="isCeremonyGuest">Raise a glass.</h1>
            <h1 class="title" v-else>Come celebrate.</h1>
            <h4 v-if="isCeremonyGuest">
              You are cordially invited to come celebrate the marriage of Matthew
              Petrie and Charles Juszczak on May 30th, 2020 at Woven Wineworks in downtown
              Portland, Oregon at 5:30 PM. A reception celebrating their marriage will be held the 
              following day on May 31st, 2020 at McMenamins Cornelius Pass Roadhouse in Hillsboro, 
              Oregon. We look forward to seeing you!
            </h4>
            <h4 v-else>
              Matt and Charlie will be married in a private ceremony on Saturday the 30th of May, 2020.
              Please join us in celebration at their wedding reception Sunday the 31st of May, 2020
              at McMenamins Cornelius Pass Roadhouse Octagonal Barn in Hillsboro, Oregon
              from 1-4 PM.
            </h4>
            <br />
            <md-button
              href="#/rsvp"
              class="md-primary md-lg"
              ><i class="material-icons">mail</i> RSVP</md-button
            >
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Let's talk details</h2>
              <h5 class="description" v-if="!isCeremonyGuest">
                Due to space constraints at our ceremony venue, we are inviting all of
                our family and friends to join us at our reception space the following
                day. We hope to see you all there!
              </h5>
            </div>
          </div>
          <div class="container">
            <div class="alert alert-danger">
              <div class="container">
                <button
                  type="button"
                  aria-hidden="true"
                  class="close"
                  @click="event => removeNotify(event, 'alert-danger')"
                >
                  <md-icon>clear</md-icon>
                </button>
                <div class="alert-icon">
                  <md-icon>info_outline</md-icon>
                </div>
                <b> MARCH 19TH COVID-19 NOTE </b> : Like you, we are watching news about COVID-19 very closely. At this time there are
                  no changes to the schedule for our wedding. Even if you RSVP and later decide that you should not come, we will completely understand. 
                  Additionally, we will not hesitate to change plans if the current risk levels remain.
                  We will be sure to contact all guests in the event the plans do change.
              </div>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout" v-if="isCeremonyGuest">
              <div class="md-layout-item md-medium-size-50 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>people</md-icon>
                  </div>
                  <h4 class="info-title">Ceremony</h4>
                  <small>Smart casual attire, followed by bubbly and light dinner</small>
                  <h4 class="info-title">Saturday, May 30th, 2020<br />5:30 PM</h4>
                  <p>
                    Woven Wineworks<br />
                    959 NW Couch St.<br />
                    Portland, OR 97209<br />
                    (near Powell's City of Books)<br /><br />
                  </p>
                  <md-button
                    href="https://goo.gl/maps/UVFssUGdcHD9Ujym8"
                    class="md-primary md-lg"
                    target="_blank"
                    ><i class="material-icons">map</i> Directions</md-button
                  >
                  <p>
                    <br /><br /><strong>Transit & Parking Information:</strong><br />
                    Woven Wineworks is easily accessible by walking, <a href="https://trimet.org/#/planner" target="_blank">Portland Streetcar, TriMet (Bus and MAX Light Rail)</a>, Lyft, Uber, Cabs
                    or you can drive yourself (but we recommend against this option). <em>Very limited</em> parking is available on-street ($), or at the nearby <a href="https://goo.gl/maps/9f7xDWTmj1KffoPU9" target="_blank">
                    Brewery Blocks garage ($$$)</a> near Whole Foods.<br /><br />
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-50 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>cake</md-icon>
                  </div>
                  <h4 class="info-title">Reception</h4>
                  <small>Casual attire, children welcome, food and drinks on us!</small>
                  <h4 class="info-title">Sunday, May 31st, 2020<br />1 PM - 4 PM</h4>
                  <p>
                    McMenamins Cornelius Pass Roadhouse<br />
                    Octagonal Barn<br />
                    4045 NE Cornelius Pass Rd.<br />
                    Hillsboro, OR 97124<br /><br />
                  </p>
                  <md-button
                    href="https://goo.gl/maps/tsmxG3iuFHXmwdWT7"
                    class="md-primary md-lg"
                    target="_blank"
                    ><i class="material-icons">map</i> Directions</md-button
                  >
                  <p>
                    <br /><br /><strong>Transit & Parking Information:</strong><br />
                    McMenamins Cornelius Pass Roadhouse is served by<br /> <a href="https://trimet.org/#/planner" target="_blank">TriMet (bus only)</a>, Lyft, Uber, Cabs
                    or you <br/> can drive yourself. Parking is available on-site, or at the nearby LA Fitness and Fred Meyer.<br /><br />
                  </p>
                </div>
              </div>
            </div>
            <div class="md-layout" v-else>
              <div class="md-layout-item md-medium-size-100 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>cake</md-icon>
                  </div>
                  <h4 class="info-title">Reception</h4>
                  <small>Casual attire, children welcome, food and drinks on us!</small>
                  <h4 class="info-title">Sunday, May 31st, 2020<br />1 PM - 4 PM</h4>
                  <p>
                    McMenamins Cornelius Pass Roadhouse<br />
                    Octagonal Barn<br />
                    4045 NE Cornelius Pass Rd.<br />
                    Hillsboro, OR 97124<br /><br />
                  </p>
                  <md-button
                    href="https://goo.gl/maps/tsmxG3iuFHXmwdWT7"
                    class="md-primary md-lg"
                    target="_blank"
                    ><i class="material-icons">map</i> Directions</md-button
                  >
                  <p>
                    <br /><br /><strong>Transit & Parking Information:</strong><br />
                    McMenamins Cornelius Pass Roadhouse is served by<br /> <a href="https://trimet.org/#/planner" target="_blank">TriMet (bus only)</a>, Lyft, Uber, Cabs
                    or you <br/> can drive yourself. Parking is available on-site, or at the nearby LA Fitness and Fred Meyer.<br /><br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/1_login_background.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    isCeremonyGuest() {
      return this.$parent.user.username === 'ceremony';
    }
  },
  methods: {
    removeNotify(e, notifyClass) {
      var target = e.target;
      while (target.className.indexOf(notifyClass) === -1) {
        target = target.parentNode;
      }
      return target.parentNode.removeChild(target);
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
